var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.75 8.125C15.5703 8.125 9.75 13.9453 9.75 21.125C9.75 21.4865 9.7648 21.8449 9.79385 22.1994C5.92858 24.0154 3.25 27.9432 3.25 32.5C3.25 38.7822 8.34276 43.875 14.625 43.875H39C44.3848 43.875 48.75 39.5098 48.75 34.125C48.75 30.4747 46.7446 27.296 43.7792 25.6251C43.8423 25.2171 43.875 24.7995 43.875 24.375C43.875 19.8877 40.2373 16.25 35.75 16.25C35.4378 16.25 35.1293 16.2677 34.8255 16.3022C32.9102 11.5111 28.2272 8.125 22.75 8.125ZM27.149 19.976C26.5144 19.3413 25.4856 19.3413 24.851 19.976L18.351 26.476C17.7163 27.1106 17.7163 28.1394 18.351 28.774C18.9856 29.4086 20.0144 29.4086 20.649 28.774L24.375 25.0481L24.375 35.75C24.375 36.6475 25.1025 37.375 26 37.375C26.8975 37.375 27.625 36.6475 27.625 35.75V25.0481L31.351 28.774C31.9856 29.4087 33.0144 29.4087 33.649 28.774C34.2837 28.1394 34.2837 27.1106 33.649 26.476L27.149 19.976Z",
    fill: "#C3CBDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/cloud-upload.d25b8eeb56e2e35c5ef7086f38c1a06b.svg";
export { ForwardRef as ReactComponent };